// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1RzOp","dragIcon":"Choice_dragIcon__OmTmT","left":"Choice_left__fiNoU","input":"Choice_input__13V1r"};